window.jQuery = window.$ = require("jquery");
var processInclude = require("./util");

$(document).ready(function () {
    // Bound first so every Bootstrap modal picks up the accessibility layer, whichever
    // component ends up showing it (DGF-3989).
    require("./helpers/accessibleDialog").enhanceBootstrapModals();

    processInclude(require("./components/menu"));
    processInclude(require("./components/cookie"));
    processInclude(require("./components/genderCultCookie"));
    processInclude(require("./components/consentTracking"));
    processInclude(require("./components/siteLocaleModal"));
    processInclude(require("./components/footer"));
    processInclude(require("./components/miniCart"));
    processInclude(require("./components/collapsibleItem"));
    processInclude(require("./components/search"));
    processInclude(require("./components/searchPlaceholder")); // DGF-4906
    processInclude(require("./components/clientSideValidation"));
    processInclude(require("./components/countrySelector"));
    processInclude(require("./components/toolTip"));
    processInclude(require("./components/slickCarouselInit"));
    processInclude(require("./components/customSelect"));
    processInclude(require("./components/fieldFormatter"));
    processInclude(require("./components/stickyHeader"));
    processInclude(require("./plpScroll"));
    processInclude(require("./wishlist/wishlistNotification"));
});

require("./thirdParty/bootstrap");
require("./components/spinner");
